import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TournamentCategoryDetailComponent } from './components/category-detail/category-detail.component';
import { TournamentEnrollComponent } from './components/enroll/enroll.component';
import { TournamentHomeComponent } from './components/home/home.component';
import { TournamentListComponent } from './components/list/list.component';
import { TournamentComponent } from './tournament.component';
import { TournamentAllComponent } from './components/all/all.component';
import { TournamentSelectCategoryComponent } from './components/select-category/select-category.component';
import { CancelSubscriptionComponent } from './components/cancel-subscription/cancel-subscription.component';
import { TournamentPlayerGamesComponent } from './components/player-games/player-games.component';

const routes: Routes = [
    {
        path: '',
        component: TournamentComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: TournamentListComponent,
            },
            {
                path: 'all',
                component: TournamentAllComponent,
            },
            {
                path: ':tournamentId',
                component: TournamentHomeComponent,
            },
            {
                path: ':tournamentId/player-games',
                component: TournamentPlayerGamesComponent,
            },
            {
                path: ':tournamentId/category/:categoryId/detail',
                component: TournamentCategoryDetailComponent,
            },
            {
                path: ':tournamentId/category/select',
                component: TournamentSelectCategoryComponent,
            },
            {
                path: ':tournamentId/category/cancel',
                component: CancelSubscriptionComponent,
            },
            {
                path: ':tournamentId/category/:categoryId/enroll',
                component: TournamentEnrollComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TournamentRoutingModule {}
